import { Injectable, Signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, catchError, map, Observable, of, tap } from 'rxjs';
import { HttpClient, httpResource } from '@angular/common/http';
import { User } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { SettingsService } from '../settings/settings.service';
import { LoggerService } from '../shared/logger.service';
import { Settings } from '../common/obj.lib';

const { apiUrl } = environment;

export abstract class CasiUserService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  // private settings: Settings = this.settingsService.getSettings();

  constructor(
    protected http: HttpClient,
    // private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch()
      .subscribe((x) => {
        console.log('query: x: ', x);
        return super.next(x);
      });
  }

  protected fetch(): Observable<User[]> {
    this.loading = true;
    // this.settings = this.settingsService.getSettings();

    return this.http.get(encodeURI(`${apiUrl}/users`))
      .pipe(
        map((response: any, i) => <User[]>response),
        map(r => r.map(x => User.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class UserDataService extends CasiUserService {

  constructor(
    http: HttpClient,
    // private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http);
  }

  //#region Private Methods

  get() {
    return this.apiService.getHttpCall('users', 'get');
  }

  setActive(userId: number, active: boolean): Promise<any> {
    active = !active;
    return this.apiService.postHttpCallAsPromise('useractive', { userId, active }, 'setActive');
  }

  // createUserResource($userId: Signal<string>) {
  //   return httpResource(() => {
  //     $userId() ? `${apiUrl}/users/${$userId()}` : undefined
  //   });
  // }

  deleteUser(userId: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`users/${userId}`, 'deleteUser');
  }

  getUsers(): Promise<User[]> {
    return this.apiService.getHttpCallAsPromise('users', 'getUsers')
      .then(data => {
        if (data && Array.isArray(data)) {
          return data.map(d => User.create(d));
        }
        return [];
      });
  }

  getRoles(): Promise<any> {
    return this.apiService.getHttpCallAsPromise('findroles', 'getRoles');
  }

  getUserRoles(userId: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`findanyuserroles/${userId}`, 'getUserRoles');
  }

  updateUser(user: any, userRoles: any, userLocations?: any, supervisorId?: number): Promise<any> {
    return this.apiService.postHttpCallAsPromise('updateuser', {
      user,
      userRoles,
      userLocations,
      supervisorId
    }, 'updateUser');
  }

  createUser(user: any, userRoles: any, userLocations?: any, supervisorId?: number): Promise<any> {
    return this.apiService.postHttpCallAsPromise('user', {
      user,
      userRoles,
      userLocations,
      supervisorId
    }, 'createUser');
  }

  getUserByEmail(email: string): Promise<any> {
    return this.apiService.postHttpCallAsPromise('finduserbyemail', { email }, 'getUserByEmail');
  }
  checkEmailExists(email: string): Promise<any> {
    return this.apiService.postHttpCallAsPromise('checkemailexists', { email }, 'getUserByEmail');
  }
  searchEmailExists(email: string | null): Observable<any> {
    // return this.apiService.postHttpCall('checkemailexists', { email }, 'getUserByEmail');
    return this.http
      .post<any>(encodeURI(`${apiUrl}/checkemailexists`), { email: email }, {
        responseType: 'json',
        withCredentials: true
      })
      .pipe(
        catchError(errorRes => {
          this.logger.error(`postHttpCall:searchEmailExists:error: `, errorRes.message);
          return of(null);
        })
      );
  }

  updateUserProfile(user: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`userprofile/${user.id}`, user, 'updateUserProfile');
  }

  updatePassword(user: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('updatepassword', user, 'updatePassword');
  }

  checkPassword(email: string, resettoken: string) {
    return this.apiService.postHttpCallAsPromise('checkpassword', {
      email,
      resettoken
    }, 'checkPassword');
  }

  signUp(user: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('signup/', user, 'signUp');
  }

  resetPassword(email: string, password: string): Promise<any> {
    this.logger.debug(`resetPassword: `, email, password);
    return this.apiService.postHttpCallAsPromise('passwordreset/', {
      email,
      password
    }, 'resetPassword');
  }

  sendResetRequest(email: string): Promise<any> {
    return this.apiService.postHttpCallAsPromise('email/sendresetlink/', {
      email
    }, 'sendResetRequest');
  }

  requestSMSToken(email: string): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`user/requestsmstoken`, {
      email
    })
  };

  requestAccessToken(email: string, code: string): Promise<any> {
    return this.apiService.postHttpCallAsPromise(`user/checksmstoken`, {
      email, code
    })
  };

  checkTerms(): Promise<any> {
    return this.apiService.getHttpCallAsPromise('termscheck', 'checkTerms');
  }

  setPassword(body: any): Promise<any> {
    this.logger.debug(`setPassword: `, body);
    return this.apiService.postHttpCallAsPromise('passwordset', body, 'setPassword');
  }
  //#endregion

}
